function NumberIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          d='M18.5 10V22H16.1313V12.4082H16.0656L13.5 14.1309V11.8809L16.2735 10H18.5Z'
          fill='currentColor'
        />
        <rect
          x='2.5'
          y='2'
          width='28'
          height='28'
          rx='3'
          stroke='currentColor'
          strokeWidth='2'
          fill='none'
        />
      </svg>
    </span>
  );
}

export default NumberIcon;
